// Mock data za Čarda Mačak riblji restoran

export const restaurantInfo = {
  name: "Čarda Mačak",
  type: "riblji restoran",
  address: "Kamenjar 387, Novi Sad",
  phone: "064 1231934",
  phoneFormatted: "+381 64 1231934",
  workingHours: "10:00 - 23:00",
  workingDays: "Svakog dana",
  instagram: "https://www.instagram.com/carda_macak_novi_sad/",
  facebook: "https://www.facebook.com/PorodicniRestoran/",
  logo: "/images/logo.png",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2805.123456789!2d19.8!3d45.25!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDXCsDE1JzAwLjAiTiAxOcKwNDgnMDAuMCJF!5e0!3m2!1ssr!2srs!4v1234567890",
  googleMapsLink: "https://maps.google.com/?q=Kamenjar+387+Novi+Sad",
  coordinates: {
    lat: 45.2671,
    lng: 19.8335
  }
};

export const features = [
  {
    icon: "music",
    title: "Tamburaši vikendom",
    description: "Živa muzika petkom i subotom"
  },
  {
    icon: "truck",
    title: "Dostava ribe",
    description: "Poručite svežu ribu na vašu adresu"
  },
  {
    icon: "fish",
    title: "Sveža riba",
    description: "Direktno iz Dunava svakodnevno"
  }
];

export const heroImages = [
  // Restoran spolja / ambijent
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnZcbxYmMOuch/IZhg6L0ATdkeA0-o_DXF_gtoIVUaeo6K/KS9zxQdkkFLjyrbjK3hOb4iJ8XNbBExt/a-5AgHIlF-3j1-kgpHNUp5AFR19RvstK/e04Q6CnO8Pym3eGOhtJVu2Ms7uh8UjlB/OVcipldrH1zJmHLN_lrUrI-sKvJsd65n/K6LDWWz2di0RCicoO52ijjJ_iAT8drsE/I_bNA40jGb85roQo9jaUgCfAEXvlYV-Y/G02WLuve6qc0Ft7-XHMcF8GvU3vm8R37/-cB02Od0qsY.jpg",
  // Riba na tanjiru
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZna1MsTqbwn_I/QI035sFSUAuj81GThnsllG7jP3O2t_yZ/MAsbZn1QGuvlZUx35YQxAqhNU2vFAupH/ZyHJwf0X8CqIP4uXs81U3czjZwVy5Dfo/jK0zVvXWdfqZNJ0pZdECyQbpdE3goC3n/0jwSJztK0QXWndxFKfsflZFLJ4nrEZft/0BHqDLj5M0pXUH9VGIJ7xYS6gu7fJjXl/HE_XBSGSi4NkoSeYuw1q4BX24f-hpY4W/srcO1UCdn3LajB-99aheWvQS86pdRczz/PXIrXKyRfuU.jpg",
  // Unutrasnjost restorana
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnSLiGq1TMnvx/tUxizUyhHao1CmQrhfWqsD4Jnhp6KEYP/t1HusVfTBUD5FnRZHWKezt3SDDjJIUPN/w0x1T4mNQUSnEv5hbqYKNHJRXzVKE9l7/unOzyeppmse4pTpQ9zleYp_XeWuoYlOL/JvJR3yZJKS4xBom3bzOVN5P3d_S2MC6N/k1ln4GMDAUyTDnnr4kpdXcXCnVBnXvYO/D6I7S8CD3N1E_M0C3O2ujI5Y9ZbZRQFN/Utc0WUAsJPQOnB30UoS-0lGqFo_y8W8u/k8YoZNJ2cOA.jpg",
  // Jelo - riba sa prilogom
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnShWVYmFPf_V/8dnmjUopu9Ouoi2l9ng4TiD8viTcd86a/Pc7OI1JbdF7C-YgMab1ZRtnaxlS7bgGg/0RaFW-rhoyYGAcpj3F_abyQjO12zEgYo/RD6yFAZXsiqBLhzXlIYnw-lDY9dyqvDP/CCr_fbp4o8R93wQLX3GkQmPta2Ran3uK/xhbbawWKQTBP37ZyjLAPYkFiB7AgZN6i/r_VZk2TQRzAo8BsKQ_FA69dDQZvJNpt9/_m92ID-RWJmGW1vLtEvHtk5va2poYFeB/lZitH0Xi4vQ.jpg",
  // Sto pored vode
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnRrPv0aRLF6K/I-LgMBBvr1y1e__ujZELRSVr-cXG8vbv/k7NeFm5CtjQhdn5CohkqHartjWMSHbI7/YScDI7n-BI_LZ2Lixv1JOXrlDtiYRrkT/Ey5g8joOFCyQ_K4zG3b38P3zo_bretXQ/TpUsMcO9Os1WcfDckmeh5pReDUynMDbD/ymRT4RC45Wp5XZ8V-AE46H7qZY7ihXOQ/WbhsPnm2l4AfteyuFX1TVQ-vrxeMolBe/BJq51umsRNP5XGQjduLhKoUoqkl4dOWT/2cIVsBMTdco.jpg"
];

export const galleryImages = [
  // Riblja čorba
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnT4VZH1mauiQ/3g714-0SznGTMX5t48gUaBM1roCQeSX1/gYAo3W8qB4EXzdRA3LGwi7Qbojek7dE3/AD5tmmPZd0XwWznupPLpYlbOjmjBTIYc/n2Xk7uLepHKv9Mf6J2b57QyJYfRqc4yw/rPKDAXCU_-ENRzg7K3pjEds0XOlpbFJL/IWNqgJzBnV6NVBF6Mnef6hJKQp27lLIQ/ddTiz1xQQQxTBFRf5Wr_cCQ55ntfPEFK/6NlGV8A63fN_Jpb1tub2b7fzUesYwA4v/AjBU0RjyQuk.jpg",
  // Pečena riba
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnZJYdImnuTV2/HHTVSQyRxbD2FA78sAS3ZDi_EE_YV28a/6twLje5oclOxDHPpTo37v0l1VlEWKJ5I/GSUh6pHwnkfvLXgZzFVkwlFRmAoPdGvX/18SyFDckSSL2zEYZ1vtKSv54yTvsjcgm/GrIAF17YmIhJEJ4QgRZ9MYwbBuJAMMKq/r6vjE4_XIqOhcJlJeE4tFBOKsDKrifaN/6B1inN2_zvX8hqGNKY-LiqLPwWJismhi/vuGHnA2gaGXot5B3AhqRfbcwb6S_mdAA/2cEfurpK2Tk.jpg",
  // Serviranje jela
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZna8Rik6J2EHy/lC_ck7I4ChbImOJdKs1lt3Ayy_jTvok4/eaplb2DbuyquMzWc6D6Vg4mP5a44B39e/8alz6fa_QUF8T4KcyOjYsdsViwBDS2gI/AunWiwNgMjBwiC4k0jekB3cYp1m-WFcr/EqsiWBYNaDLzGJ8D5YXadcFzxaaFr1GZ/dKzKih2W_llH9dW4eFzgo_VXhvZx-F6W/FgUddtrRCYsvAP5PWsGuwmnEwJ-ZoH-v/MbbKTzQXbY8AhE5m8hp75hJ-Bll444VJ/ReP1zJaca9o.jpg",
  // Terasa restorana
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnWmABJPY0m5H/jO-BlBjpkwUBXy36rxXLI4jpmi2lHiuA/Sm6YitsfUb81JslwBCNNB5RlFbRZkfju/wToBiRDW5gR3ANiSb1l7a_9BhB8F9SZ4/1uFasM3tAwBIdzpK5cCJ5aqqsmbagiyH/IUkpQphCMeaHpwwwvHDmd9ZHhdXv44Xv/c-6OnwSq0516oGFb7mFA65GaD-PWNqyL/newO62MPSVVJGootWbPS-oOyoYooD_0q/zAiySNgarfvR8V-many4R8ON84zZ_dj9/muPHQ7AbraE.jpg",
  // Jelo na stolu
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnTWMgcX-eIKW/cjWOHCo5KUSS7OIiKafq4st6U4mKjM9x/_wy_JcNJe0XkDX2NYv2FJ4kpLSl9O076/rsBR-LmSFGQ4M2Lek_1W5GbKowBXBYGJ/-i2t88WUNDb9lb71cML53lVAZyll55pF/U0Yi0qX36q9tqlGmYtOehTlqgE29Shf5/cwgWhoJGU4TPYUs57v3kyR3D8Ejvjv-j/8wvatVqSZy7kjrh-A2QvbzCenQKQUhh3/A9hAEpA80ZQir3qfRuDkG7aan7aaq6Sb/WABBuNtn8Ck.jpg",
  // Enterier 
  "https://i.wfolio.com/x/Sjpgrm2v20FR6Cth5viRk6Iir5aoqG4h/ZXWGJmu7EQlhnv6D9ELHSMzGOBuFicXp/OGcM34slpvmXTMkbuJagSabNEGEWnkTc/ydRS-kKPjW1kb0mB8UiPrsaTdskUoeGD/I8-TZWQFoiYx-hr6pZNbX98QhGXH52ap/F_AShwIRlmndYIpGHJFan0_TgxU89Xli/0zNaSWci_2dyI3sq4HWio06pRYC4OirH/51QbZ5HotKfg850B14jfeGq5-D4zVIQ1/80S7sfe3kvLJrJkjzREZnYHODFiCB0oM/cW87442KpOzxNZ5FgjFV13CYnV8uzH3T/8KPiiXlvn8EDnjoY-JW1EDzf6SwqQQi3/wszlwk-rMX2GLVUpDizY9zpqYhWnAoLF/jlnO6sddor9j6bW6m3pZ0ZsFPHMYJoAD/59-Mo8pkfPxEoW6KFy5MRoQ-veVqOzv8/E4Ugoyf3D9n7j7ObKOi7hNbp80P2Y0da/sI4N5W5EDYBSnfpjDlHWXQVX_ijAAXq1/Ww_Nqj5wA-cSCV46N-JeoW0Omu_xpZob/hyGEmz4N2gg.jpg"
];

// Reorganizovan meni - Čorbe i Prilozi spojeni, bolja organizacija
export const menu = {
  ribljiSpecijaliteti: {
    title: "Riblji Specijaliteti",
    subtitle: "čorbe i paprikaš",
    icon: "soup",
    items: [
      { name: "Riblja čorba", description: "Tradicionalni recept", price: 720 },
      { name: "Riblji paprikaš bez kosti", description: "Bogat ukus", price: 1120 }
    ]
  },
  riba: {
    title: "Sveža Riba",
    subtitle: "pečena i pohovana",
    icon: "fish",
    items: [
      { name: "Som", weight: "350g", price: 1350 },
      { name: "Smuđ", weight: "350g", price: 1390 },
      { name: "Smuđ file", weight: "300g", price: 1680 },
      { name: "Smuđ Orli", weight: "350g", price: 1690 },
      { name: "Kečiga", weight: "350g", price: 1680 },
      { name: "Pastrmka", weight: "350g", price: 1290 },
      { name: "Štuka", weight: "350g", price: 1100 },
      { name: "Šaran", weight: "350g", price: 1190 },
      { name: "Šaran dimljeni", weight: "350g", price: 1390 },
      { name: "Karaš, melez", weight: "350g", price: 790 },
      { name: "Jesetra", weight: "350g", price: 590 },
      { name: "Girice", weight: "300g", price: 590 },
      { name: "Dimljena pastrmka fileti", weight: "300g", price: 1590 }
    ]
  },
  rostilj: {
    title: "Roštilj",
    subtitle: "sa žara",
    icon: "flame",
    items: [
      { name: "Ćevapi", weight: "250g", price: 890 },
      { name: "Ražnjići", weight: "250g", price: 890 },
      { name: "Pljeskavica", weight: "250g", price: 890 },
      { name: "Roštilj kobasica", weight: "250g", price: 890 },
      { name: "Pileće belo meso", weight: "250g", price: 990 },
      { name: "Mešano meso", weight: "700g", price: 1790 },
      { name: "Karađorđeva šnicla", weight: "400g", price: 1290 },
      { name: "Bečka šnicla", weight: "300g", price: 1090 }
    ]
  },
  salateIPrilozi: {
    title: "Salate & Prilozi",
    icon: "salad",
    items: [
      { name: "Sezonska salata", price: 320 },
      { name: "Šopska salata", price: 350 },
      { name: "Srpska salata", price: 350 },
      { name: "Bašta salata", price: 350 },
      { name: "Ljuta zelena paprika", weight: "kom", price: 180 },
      { name: "Pomfrit", weight: "250g", price: 280 },
      { name: "Hleb", weight: "parče", price: 80 }
    ]
  },
  deserti: {
    title: "Deserti",
    subtitle: "slatki završetak",
    icon: "cake",
    items: [
      { name: "Gomboce sa šljivama", price: 350 },
      { name: "Banana split", price: 380 },
      { name: "Šnenokle", price: 380 },
      { name: "Rezanci sa makom", price: 380 },
      { name: "Štrudla", subtitle: "mak, jabuka ili orah", price: 380 }
    ]
  }
};
